import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';

import React from 'react';

interface AIChatPreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const AIChatPreview = ({ content: _content, onClose }: AIChatPreviewProps) => {
  if (!_content) return null;

  let content = _content;

  if (content.content.response[0]?.answer) {
    const response: any[] = [];
    content.content.response.forEach((item: any) => {
      response.push({
        content: item.question,
        role: 'user',
      });
      response.push({
        content: item.answer.replace(
          /\[\[(\d+)\]\]\((https?:\/\/[^\s)]+)\)/g,
          (_match: string, num: string, url: string): string => {
            return `<a href="${url}">[${num}]</a>`;
          },
        ),
        role: 'assistant',
        references: item.references,
      });
    });

    content = {
      ...content,
      content: {
        response: response,
      },
    };
  } else if (content.content.response?.answer) {
    content = {
      ...content,
      content: {
        response: [
          {
            content: content.content.response.query,
            role: 'user',
          },
          {
            content:
              content.content.response.answer.replace(
                /\[\[(\d+)\]\]\((https?:\/\/[^\s)]+)\)/g,
                (_match: string, num: string, url: string): string => {
                  return `<a href="${url}">[${num}]</a>`;
                },
              ) + `<i>${content.content.response.disclaimer}</i>`,
            role: 'assistant',
            references: content.content.response.references,
          },
        ],
      },
    };
  }

  const onCopy = async () => {
    if (!content) return;

    const parsedContent = typeof content.content === 'string' ? JSON.parse(content.content) : content.content;
    const responses = Array.isArray(parsedContent.response) ? parsedContent.response : [parsedContent.response];
    const textToCopy = responses
      //.filter((resp: any) => resp.role === 'assistant')
      .map(
        (resp: any) =>
          resp.content.replace(/<[^>]*>/g, '').trim() +
          (resp.references ? '\n\n' + resp.references.map((ref: any) => `${ref.title}: ${ref.link}`).join('\n') : ''),
      )
      .join('\n\n');

    const formattedHtmlContent = responses
      // .filter((resp: any) => resp.role === 'assistant')
      .map(
        (resp: any) =>
          (resp.role === 'assistant' ? resp.content.trim() : `<b>${resp.content.trim()}</b>`) +
          (resp.references
            ? resp.references.map((ref: any) => `<a href="${ref.link}">${ref.title}</a>`).join('<br>')
            : ''),
      )
      .join('<br><br>');

    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([formattedHtmlContent], { type: 'text/html' }),
        'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
      }),
    ]);
  };

  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="Stylus AI"
      subTitle="Stylus AI Conversation"
      onCopy={onCopy}
    >
      <div className="px-md-13 px-lg-14 text-start">
        <div className="v-card">
          {(() => {
            const parsedContent = typeof content.content === 'string' ? JSON.parse(content.content) : content.content;
            const responseData = Array.isArray(parsedContent.response)
              ? parsedContent.response
              : [parsedContent.response];
            return responseData
              .filter((resp: any) => resp.role === 'user' || resp.role === 'assistant')
              .reduce((acc: any[], resp: any, index: number) => {
                if (resp.role === 'user') {
                  const nextResp = responseData[index + 1];
                  if (nextResp && nextResp.role === 'assistant') {
                    acc.push(
                      <React.Fragment key={index}>
                        <h3 className="mb-6 font-bold">{resp.content.replace(/<[^>]*>/g, '').trim()}</h3>

                        <div
                          className="richText [&_h2]:!my-3 [&_h3]:!my-3 [&_p]:!my-3"
                          dangerouslySetInnerHTML={{ __html: nextResp.content }}
                        ></div>

                        {nextResp.references &&
                          nextResp.references.map((ref: any, refIndex: number) => (
                            <div key={refIndex} className="gap-2">
                              <a className="underline" href={ref.link} target="_blank" rel="noopener noreferrer">
                                {ref.title}
                              </a>
                            </div>
                          ))}
                        <hr className="my-3 border-t border-gray-200" />
                      </React.Fragment>,
                    );
                  }
                }
                return acc;
              }, []);
          })()}
        </div>
      </div>
    </ContentPreviewWraper>
  );
};

export default AIChatPreview;
